import { useQuery } from "@tanstack/react-query";
import { fetchAnalysisConfigs } from "~/_legacy/apis/fetch-analysis-configs";

export const ANALYSIS_CONFIGS_BY_BRANCH_QUERY_KEY = "analysisConfigsByBranch";

export function useGetAnalysisConfigsByBranch({
  branchUid,
  branchVersionId,
}: {
  branchUid?: string;
  branchVersionId?: number;
}) {
  return useQuery({
    queryKey: [ANALYSIS_CONFIGS_BY_BRANCH_QUERY_KEY, branchUid, branchVersionId],
    queryFn: () => fetchAnalysisConfigs({ branchUid: branchUid!, branchVersionId }),
    enabled: Boolean(branchUid),
  });
}
